<div class="bg-light grid-container grid-4 height-100 ipe-value-card">
    <div class="color-radius" [style.background-color]="range ? range.color : '#424242'"></div>
    <div class="grid-span-3 medium-padding-top medium-padding-bottom medium-padding-right">
        <div class="display-flex space-between">
            <div>
                <edit-text [disabled]="!hasTileAdminOption" [(ngModel)]="_tile.name" (ngModelChange)="updateTileName()" />
                @if (!_tile.error) {
                    <p class="ipe-subtitle">{{ subtitle | translate }}</p>
                }
            </div>
            <div class="no-print">
                @if (hasTileAdminOption) {
                    <ui-icon-button iconName="configure" size="small" (click)="editTile($event)" />
                    <ui-icon-button iconName="delete" size="small" (click)="deleteTile($event)" />
                }
            </div>
        </div>
        <p class="text-left">
            @if (_tile.value) {
                <span class="ipe-value" [style.color]="range ? range.color : '#424242'">
                    {{ displayValue | localnumber }}
                </span>
            } @else {
                <span class="ipe-value" [style.color]="range ? range.color : '#424242'">--</span>
            }
            <span class="ipe-value-unit" [innerHTML]="_unitToDisplay"></span>
        </p>
        @if (_tile.error) {
            <p class="text-left">
                <ui-icon name="warning" color="danger" size="small" />
                <span class="ipe-error">{{ 'IPE.' + _tile.error | translate }}</span>
            </p>
        }
    </div>
</div>
